import FrancisProfile from "../../../assets/Francis.png";
import GaneshProfile from "../../../assets/Ganesh.png";
import SubhaProfile from "../../../assets/Subha.png";
import varun from "../../../assets/VARUN.png"
export const MarketingTeamProfile = [
  { id: 1, title: "Varunkrishna S", imgUrl: varun},
  // { id: 2, title: "Subha V", imgUrl: SubhaProfile },
  // { id: 3, title: "Ganesh M", imgUrl: GaneshProfile },
];
